import { render } from "./topBox.vue?vue&type=template&id=79600af1&scoped=true&ts=true"
import script from "./topBox.vue?vue&type=script&lang=ts"
export * from "./topBox.vue?vue&type=script&lang=ts"

import "./topBox.vue?vue&type=style&index=0&id=79600af1&lang=scss&scoped=true"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79600af1"]])

export default __exports__